export const CREATE_SCRIBE_FROM_TEMPLATE = 'CREATE_SCRIBE_FROM_TEMPLATE';
export const CREATE_SCRIBE_FROM_TEMPLATE_SUCCESS = 'CREATE_SCRIBE_FROM_TEMPLATE_SUCCESS';
export const CREATE_SCRIBE_FROM_TEMPLATE_FAILED = 'CREATE_SCRIBE_FROM_TEMPLATE_FAILED';

export const GET_SCRIBE_TEMPLATES = 'GET_SCRIBE_TEMPLATES';
export const GET_SCRIBE_TEMPLATES_FAILED = 'GET_SCRIBE_TEMPLATES_FAILED';
export const GET_SCRIBE_TEMPLATES_BY_CATEGORY_SUCCESS = 'GET_SCRIBE_TEMPLATES_BY_CATEGORY_SUCCESS';

export const SAVE_SCRIBE_AS_TEMPLATE = 'SAVE_SCRIBE_AS_TEMPLATE';
export const SAVE_SCRIBE_AS_TEMPLATE_SUCCESS = 'SAVE_SCRIBE_AS_TEMPLATE_SUCCESS';
export const SAVE_SCRIBE_AS_TEMPLATE_FAILED = 'SAVE_SCRIBE_AS_TEMPLATE_FAILED';

export const CONTENTFUL_OAUTH_SUCCESS = 'CONTENTFUL_OAUTH_SUCCESS';
export const CONTENTFUL_OAUTH_INVALID = 'CONTENTFUL_OAUTH_INVALID';
export const CONTENTFUL_OAUTH_LOADED = 'CONTENTFUL_OAUTH_LOADED';

export function createScribeFromTemplate(templateId, replaceHistory = false) {
  return {
    type: CREATE_SCRIBE_FROM_TEMPLATE,
    templateId,
    replaceHistory
  };
}
export function createScribeFromTemplateSuccess() {
  return {
    type: CREATE_SCRIBE_FROM_TEMPLATE_SUCCESS
  };
}
export function createScribeFromTemplateFailed() {
  return {
    type: CREATE_SCRIBE_FROM_TEMPLATE_FAILED
  };
}

export const getScribeTemplates = () => ({
  type: GET_SCRIBE_TEMPLATES
});

export const getScribeTemplatesFailed = error => ({
  type: GET_SCRIBE_TEMPLATES_FAILED,
  error
});

export const getScribeTemplatesByCategorySuccess = categories => ({
  type: GET_SCRIBE_TEMPLATES_BY_CATEGORY_SUCCESS,
  categories
});

export const saveScribeAsTemplate = scribeId => ({
  type: SAVE_SCRIBE_AS_TEMPLATE,
  scribeId
});

export const saveScribeAsTemplateSuccess = () => ({
  type: SAVE_SCRIBE_AS_TEMPLATE_SUCCESS
});

export const saveScribeAsTemplateFailed = error => ({
  type: SAVE_SCRIBE_AS_TEMPLATE_FAILED,
  error
});

export const contentfulOauthSuccess = accessToken => ({
  type: CONTENTFUL_OAUTH_SUCCESS,
  payload: accessToken
});

export const contentfulOauthLoaded = accessToken => ({
  type: CONTENTFUL_OAUTH_LOADED,
  payload: accessToken
});

export const contentfulOauthInvalid = () => ({
  type: CONTENTFUL_OAUTH_INVALID
});
